import { CombinedIncome } from "../../types/income";
import { BankSourcesTable } from "./components/BankSourcesTable";
import { PayrollTable } from "./components/PayrollTable";
import { PaystubTable } from "./components/PaystubTable";
import { W2Table } from "./components/W2Table";

export const TablesSlice = ({ income }: { income: CombinedIncome }) => {
  switch (income.verified_source_type) {
    case "bank":
      return <BankSourcesTable income={income.items} />;
    case "payroll":
      return <PayrollTable income={income.items} />;
    case "w2":
      return <W2Table income={income.items} />;
    case "paystub":
      return <PaystubTable income={income.items} />;
  }
};
